// Employee constants
export const EMPLOYEE_STATUSES = ['ACTIVE', 'ON_LEAVE', 'PROBATION', 'TERMINATED', 'RESIGNED', 'RETIRED'];
export const EMPLOYMENT_TYPES = ['FULL_TIME', 'PART_TIME', 'CONTRACT', 'INTERN', 'FREELANCE'];
export const GENDERS = ['MALE', 'FEMALE', 'OTHER', 'PREFER_NOT_TO_SAY'];
export const MARITAL_STATUSES = ['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED', 'OTHER'];
export const LIFECYCLE_EVENT_TYPES = ['HIRED', 'PROMOTED', 'TRANSFERRED', 'TERMINATED', 'RESIGNED', 'ON_LEAVE', 'RETURNED', 'PROBATION_END', 'SALARY_CHANGE', 'ROLE_CHANGE', 'OTHER'];

// Job constants
export const JOB_STATUSES = ['DRAFT', 'OPEN', 'ON_HOLD', 'CLOSED', 'FILLED'];
export const PRIORITY_OPTIONS = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'];

// Applicant constants
export const APPLICANT_STATUSES = ['APPLIED', 'SCREENING', 'SHORTLISTED', 'INTERVIEW', 'OFFERED', 'HIRED', 'REJECTED', 'WITHDRAWN'];
export const APPLICANT_SOURCES = ['CAREER_PAGE', 'LINKEDIN', 'INDEED', 'REFERRAL', 'INTERNAL', 'AGENCY', 'SOCIAL_MEDIA', 'OTHER'];

// Interview constants
export const INTERVIEW_TYPES = ['PHONE', 'VIDEO', 'IN_PERSON', 'PANEL', 'TECHNICAL', 'HR'];
export const INTERVIEW_STATUSES = ['SCHEDULED', 'COMPLETED', 'CANCELLED', 'NO_SHOW'];

// Offer constants
export const OFFER_STATUSES = ['DRAFT', 'SENT', 'ACCEPTED', 'REJECTED', 'EXPIRED', 'WITHDRAWN'];

// Status color maps for MUI Chips
export const EMPLOYEE_STATUS_COLORS = {
  ACTIVE: 'success',
  ON_LEAVE: 'warning',
  PROBATION: 'info',
  TERMINATED: 'error',
  RESIGNED: 'default',
  RETIRED: 'default',
};

export const JOB_STATUS_COLORS = {
  OPEN: 'success',
  DRAFT: 'default',
  ON_HOLD: 'warning',
  CLOSED: 'error',
  FILLED: 'info',
};

export const APPLICANT_STATUS_COLORS = {
  APPLIED: '#9e9e9e',
  SCREENING: '#2196f3',
  SHORTLISTED: '#00bcd4',
  INTERVIEW: '#ff9800',
  OFFERED: '#9c27b0',
  HIRED: '#4caf50',
  REJECTED: '#f44336',
  WITHDRAWN: '#607d8b',
};

export const INTERVIEW_STATUS_COLORS = {
  SCHEDULED: 'info',
  COMPLETED: 'success',
  CANCELLED: 'error',
  NO_SHOW: 'warning',
};

export const OFFER_STATUS_COLORS = {
  DRAFT: 'default',
  SENT: 'info',
  ACCEPTED: 'success',
  REJECTED: 'error',
  EXPIRED: 'warning',
  WITHDRAWN: 'default',
};

export const PRIORITY_COLORS = {
  LOW: 'default',
  MEDIUM: 'info',
  HIGH: 'warning',
  URGENT: 'error',
};

// Helper to format enum values for display
export const formatEnumLabel = (value) => {
  if (!value) return '-';
  return value.replace(/_/g, ' ');
};
